module.exports = __webpack_public_path__ + "img/layout_top.3513d994.svg";